import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function CommonModal(props) {
  const {
    type,
    open,
    setModal,
    projectName,
    width,
    bodyHeight,
    body,
    editable,
    setEditable,
    footer = undefined,
    padding,
    addClaim,
    pendingPM,
    reviewsClaims,
    childAllowance,
    claimDetailModal,
    addRequestModal,
  } = props;
  return (
    <Modal
      className={`${addRequestModal && 'add_request_modal'} ${
        addClaim
          ? 'add-claim'
          : pendingPM
          ? 'pending-pm'
          : reviewsClaims
          ? 'reviews-claims'
          : childAllowance
          ? 'child-allowance'
          : claimDetailModal
          ? 'claim-detail-modal'
          : ''
      }`}
      id="commonModal"
      isOpen={open}
      backdrop={(true, 'static')}
      onOpened={() => {
        document.body.style.overflow = 'hidden';
      }}
      onClosed={() => {
        document.body.style.overflow = 'auto';
      }}
      onExit={() => {
        document.body.style.overflow = 'auto';
      }}
      centered={true}
      style={{
        maxWidth: width,
      }}
    >
      <ModalHeader
        toggle={() => {
          editable ? setEditable(!editable) : '', setModal(!open);
        }}
      >
        {projectName}
      </ModalHeader>
      <ModalBody
        style={{
          height: bodyHeight,
        }}
      >
        <div className="text-break" style={{ padding: padding && padding }}>
          {body()}
        </div>
      </ModalBody>
      {(footer || type === 'status') && (
        <ModalFooter>
          {type === 'status' ? (
            <Button color="secondary" onClick={() => setModal(!open)}>
              Cancel
            </Button>
          ) : (
            footer()
          )}
        </ModalFooter>
      )}
    </Modal>
  );
}
